export default "__VITE_PUBLIC_ASSET__816cb2f5__"